import { styled, SxProp, View } from 'dripsy';
import { useTranslation } from 'react-i18next';
import { Linking, Pressable } from 'react-native';

import { useStore } from 'store/store';
import { TextBody, TextCaption } from '../typography/UniTypography';

const FOOTER_HEIGHT = 126;
const PressableView = styled(Pressable)();

interface FooterProps {
  sx?: SxProp;
}

export const Footer: React.FC<FooterProps> = () => {
  const { t } = useTranslation();
  const store = useStore();
  const year = new Date().getFullYear();

  return (
    <View sx={{ ...styles.container }}>
      <TextBody>{t('earn-invest::glossary.copyright', { year, vendor: store.brand })}</TextBody>
      <View sx={{ ...styles.hyperlinkGroup }}>
        <Hyperlink
          label={t('earn-invest::glossary.disclaimer')}
          url="https://static.utgl.io/tenant/utgl/legal/UniTrust%20Global%20Limited-Disclaimer.pdf"
        />
        <Hyperlink
          label={t('earn-invest::glossary.risk-disclosure')}
          url="https://static.utgl.io/tenant/utgl/legal/UniTrust%20Global%20Limited-Risk%20Disclosure%20Statement.pdf"
        />
        <Hyperlink
          label={t('earn-invest::glossary.privacy-policy')}
          url="https://static.utgl.io/tenant/utgl/legal/UniTrust_Global_Limited_Personal_Information_Collection_and_Privacy.pdf"
        />
        <Hyperlink
          label={t('earn-invest::glossary.terms-and-conditions')}
          url="https://static.utgl.io/tenant/utgl/legal/UniTrust%20Global%20Limited-Standard%20Terms.pdf"
        />
        <Hyperlink
          label={t('earn-invest::glossary.cookies-policy')}
          url="https://static.utgl.io/tenant/utgl/legal/UniTrust%20Global%20Limited%20-%20Cookies%20Policy_2021Jan.pdf"
        />
      </View>
    </View>
  );
};

const Hyperlink = ({ label, url }: { label: string; url: string }) => {
  const onPress = () => {
    Linking.openURL(url);
  };

  return (
    <PressableView>
      <TextCaption sx={{ color: '$textThemeSecondary', textDecorationLine: 'underline' }} onPress={onPress}>
        {label}
      </TextCaption>
    </PressableView>
  );
};

enum StyleName {
  container = 'container',
  hyperlinkGroup = 'hyperlinkGroup'
}

const styles: Record<StyleName, SxProp> = {
  container: {
    paddingX: '$4',
    height: FOOTER_HEIGHT,
    justifyContent: 'center',
    alignItems: 'center',
    gap: '$4'
  },
  hyperlinkGroup: { flexDirection: 'row', alignItems: 'center', justifyContent: 'center', gap: '$5', flexWrap: 'wrap' }
};
